import styled from "styled-components/macro";
import { useSettings } from "../../../contexts/SettingsManager/SettingsManager";
import { HtmlTooltip } from "../GroupMetrics/HtmlTooltip";
import { producingColor, untaggedColor } from "../../../constants/colors";
import { getModalArowTopCSS } from "../ExplainerTooltip";
import { Link } from "react-router-dom";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { useIsDarkMode } from "store/atoms";

export default function PredictedMetricTooltip({
  children,
}: {
  children: React.JSX.Element;
}) {
  const { estimatedFutureMetricPercent } = useSettings();
  return (
    <HtmlTooltip
      title={
        <PredictedMetricTooltipContent
          estimatedFutureMetricPercent={estimatedFutureMetricPercent}
        />
      }
      leaveDelay={500}
      PopperProps={{ style: { pointerEvents: "all" } }}
    >
      {children}
    </HtmlTooltip>
  );
}

function PredictedMetricTooltipContent({
  estimatedFutureMetricPercent,
}: {
  estimatedFutureMetricPercent: number;
}) {
  const ckey = useCustomerKey();
  const [isDarkMode] = useIsDarkMode();
  return (
    <PredictedMetricTooltipStyles {...{ $isDarkMode: isDarkMode }}>
      <p>
        Your metrics are the predicted values at the end of the shift (or day),
        assuming of the time remaining:
      </p>
      <p style={{ margin: "0.5rem 0" }}>
        - {(estimatedFutureMetricPercent * 100).toFixed(0)}% is{" "}
        <span className="producing square" /> producing
        <br />- {((1 - estimatedFutureMetricPercent) * 100).toFixed(0)}% is{" "}
        <span className="unknown square" /> unknown.
      </p>
      <p>
        You can change these values from the{" "}
        <Link to={`/${ckey}/settings`}>Settings page</Link>.
      </p>
    </PredictedMetricTooltipStyles>
  );
}

const PredictedMetricTooltipStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  ${({ $isDarkMode }) => getModalArowTopCSS($isDarkMode)}
  padding: 0.5rem;
  .square {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-bottom: -2px;
  }
  .producing {
    background: ${producingColor};
  }
  .unknown {
    background: ${untaggedColor};
  }
`;
